<template>
    <checkout-popup-layout :open="true">
        <checkout-step-two-layout>
            <template v-slot:header>
                <p class="update_payment_method__title">{{ $t('updatePayment.title') }}</p>
            </template>

            <template v-slot:content>
                <div class="update_payment_method__list-block">
                    <template v-if="subscriptions.length">
                        <label>{{ $t('updatePayment.subscriptionsToUpdate') }}:</label>
                        <ul class="no-style" data-test="subscriptions-list">
                            <template v-for="subscription in subscriptions">
                                <li v-if="subscription.balance == 0">
                                    <b>{{ subscription.title }}</b>
                                </li>
                                <li v-else>
                                    <b>{{ subscription.title }}</b>&nbsp;<br class="show-on-mobile" />
                                    ({{ $t('updatePayment.yourBalance') }} {{ currencySymbol }}{{ subscription.balance }})
                                </li>
                            </template>
                        </ul>
                    </template>
                    <template v-else>
                        <label>{{ $t('updatePayment.noSubscriptions') }}</label>
                    </template>
                </div>
            </template>

            <template v-slot:paypal>
                <paypal-payment
                    :braintree-client-instance="braintreeClientInstance"
                    create-payment-method-endpoint="update-payment-method-create"
                    :create-payment-method-form-data="formData"
                    @received-token="receivedToken"></paypal-payment>
            </template>

            <template v-slot:credit-card>
                <credit-card-payment
                    :braintree-client-instance="braintreeClientInstance"
                    :submit-title="$t('updatePayment.button')"
                    create-payment-method-endpoint="update-payment-method-create"
                    :create-payment-method-form-data="formData"
                    @received-token="receivedToken"></credit-card-payment>
            </template>
        </checkout-step-two-layout>
    </checkout-popup-layout>
</template>

<script>
import braintree from 'braintree-web';

import CheckoutPopupLayout from './CheckoutPopupLayout.vue';
import CheckoutStepTwoLayout from './CheckoutStepTwoLayout.vue';
import PaypalPayment from './payment_handlers/PaypalPayment.vue';
import CreditCardPayment from './payment_handlers/CreditCardPayment.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CheckoutPopupLayout,
        CheckoutStepTwoLayout,
        PaypalPayment,
        CreditCardPayment,
    },
    props: ['braintreeClientToken', 'subscriptions', 'currencySymbol'],

    data: function () {
        return {
            braintreeClientInstance: null,
        };
    },

    computed: {
        ...mapState(['contact']),
        formData() {
            return {
                email: this.contact.email,
            };
        },
    },

    mounted() {
        braintree.client
            .create({
                authorization: this.braintreeClientToken,
            })
            .then((clientInstance) => {
                this.braintreeClientInstance = clientInstance;
            });
    },

    methods: {
        receivedToken(token) {},
    },
};
</script>
